










import Component from 'vue-class-component'
import Vue from 'vue'
import DefaultHeader from '@/main/default-header.vue'
import RespondecoImpact from '@/business/home/components/impact.vue'
import UnifyPage from '@/shared/components/unify/unify-page.vue'
import { Hooks } from '@/shared/interfaces/hooks'
import { Injector } from '@/config/dependency-injection'
import { MetaService } from '@/shared/services/meta-service'

@Component({
  name: 'impact',
  components: { UnifyPage, RespondecoImpact, DefaultHeader },
})
export default class Impact extends Vue implements Hooks {
  private metaService = Injector.get(MetaService)

  public mounted() {
    this.metaService.updateDocumentTitle('about.impact')
  }
}
